import Axios from 'axios'
import config from 'src/config'

export type Answer = {
  id: number
  content: string
}

export type QuestionType = {
  id: number
  content: string
  answers: Answer[]
}

export type QuestionsResponse = {
  hasCompletedQuiz: boolean
  questions: QuestionType[]
}

export type SendAnswersRequest = {
  questionId: number
  answerIds: number[]
}

export type ResultResponse = {
  isCorrect: boolean
  score: number
  totalScore: number
}

export const startQuestion = async (id: number) => {
  try {
    const response = await Axios({
      method: 'post',
      url: `${config.apiUrl}/api/questions/${id}/quiz_attempts`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error starting question:', error)
    throw error
  }
}

export const getQuestions = async (): Promise<QuestionsResponse> => {
  try {
    const response = await Axios({
      method: 'get',
      url: `${config.apiUrl}/api/questions`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        'Content-Type': 'application/json',
      },
    })
    return response.data as QuestionsResponse
  } catch (error) {
    console.error('Error fetching question:', error)
    throw error
  }
}

export const sendAnswers = async (data: SendAnswersRequest): Promise<void> => {
  try {
    const response = await Axios({
      method: 'put',
      url: `${config.apiUrl}/api/questions/${data.questionId}/quiz_attempts/update_attempt`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        'Content-Type': 'application/json',
      },
      data: {
        answer_ids: data.answerIds,
      },
    })

    return response.data
  } catch (error) {
    console.error('Error submitting answers:', error)
    throw error
  }
}

export const getResult = async (question_number: number): Promise<ResultResponse> => {
  try {
    const response = await Axios({
      method: 'get',
      url: `${config.apiUrl}/api/questions/${question_number}/quiz_attempts/result`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching result:', error)
    throw error
  }
}


export const getWinners = async () => {
}

export interface LeaderboardApiEntry {
  rank: number
  user_id: number
  full_name: string
  company: string
  score: number
  total_time: number
}

export interface LeaderboardApiResponse {
  success: boolean
  leaderboard: LeaderboardApiEntry[]
}

export async function fetchLeaderboard(): Promise<LeaderboardApiResponse> {
  const response = await fetch(`${config.apiUrl}/api/leaderboard`)
  if (!response.ok) {
    throw new Error(`Leaderboard fetch failed: ${response.status} ${response.statusText}`)
  }
  return response.json() as Promise<LeaderboardApiResponse>
}